<template>
<div class="data-player">
  <button class="play-ctrl-btn" @click="onPlayBtnClick">
    <i :class="isPlaying ? 'el-icon-video-pause' : 'el-icon-video-play'" />
  </button>

  <div class="play-progress">
    <el-slider v-model="dataIndex" :min="0" :max="options.length - 1" :show-tooltip="false" />
  </div>

  <div class="play-config-wrapper">
    <label>每帧播放间隔</label>
    <el-input v-model="seconds" type="number" :disabled="isPlaying" size="mini" style="width:150px;">
      <template #append>秒</template>
    </el-input>
  </div>
</div>
</template>

<script>
export default {
  name: 'DataPlayer',
  props: {
    value: {},
    options: {
      required: true,
      type: Array
    },
    defaultInterval: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      isPlaying: false,
      seconds: this.defaultInterval
    }
  },
  computed: {
    dataIndex: {
      get () {
        return this.value
      },
      set (index) {
        this.$emit('input', index)
      }
    }
  },
  methods: {
    clearPlayTimer () {
      clearTimeout(this.playerTimer)
      clearTimeout(this.playerTimer2)
    },
    enablePlayTimer () {
      this.clearPlayTimer()

      this.playerTimer = setTimeout(() => {
        this.dataIndex += 1

        this.playerTimer2 = setTimeout(() => {
          if (this.dataIndex < (this.options.length - 1)) {
            this.enablePlayTimer()
          } else {
            this.isPlaying = false
          }
        }, 0)
      }, this.seconds * 1000)
    },
    onPlayBtnClick () {
      this.isPlaying = !this.isPlaying

      if (this.isPlaying) {
        const {options} = this
        const {length} = options

        if (length > 1) {
          if (this.dataIndex === (length - 1)) {
            this.dataIndex = 0
          }

          this.enablePlayTimer()
        }
      } else {
        this.clearPlayTimer()
      }
    }
  },
  watch: {
    imgInfos () {
      this.clearPlayTimer()
      this.isPlaying = false
    }
  },
  beforeDestroy () {
    this.clearPlayTimer()
  }
}
</script>

<style lang="scss">
.data-player {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 10px 0;
  white-space: nowrap;

  .play-ctrl-btn {
    font-size: 28px;
    width: 28px;
    height: 28px;
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    color: #409eff;
    background-color: transparent;
    cursor: pointer;

    &:hover {
      color: #66b1ff;
    }

    &:active {
      color: #3a8ee6;
    }
  }

  .play-progress {
    width: 200px;
  }

  .play-config-wrapper {
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DataPlayer/index.vue